import React from "react";

import Glide from "@glidejs/glide";

import { Col } from "reactstrap";

function CarouselConstant() {
  const submitEvent = new SubmitEvent("submit");
  React.useEffect(() => {
    new Glide(".glide", {
      type: "carousel",
      startAt: 0,
      focusAt: 1,
      perView: 3,
      autoplay: 3000,
    }).mount();
  });
  return ( 
    <section className="section bg-default">
      <Col className="ml-auto mr-auto" md="8">
        <div className="glide">
          <div className="glide__track" data-glide-el="track">
            <ul className="glide__slides">
              <li className="glide__slide">
                <a href="https://www.exeter.ac.uk/study/pg-research/csc-scholarships/environment/" target="_blank" onClick={submitEvent} rel="noreferrer">
                  <img
                    className="img-center"
                    alt="..."
                    height="125"
                    src={require("assets/img/faces/uoe-logo.png")}
                    width="125"
                  ></img>
                </a>
              </li>
              <li className="glide__slide">
                <a href="https://www.uwe.ac.uk/research/postgraduate-research-study/how-to-apply/studentship-opportunities/internet-of-things-over-wireless-networks" target="_blank" onClick={submitEvent} rel="noreferrer">
                  <img
                    className="img-center"
                    alt="..."
                    height="125"
                    src={require("assets/img/faces/UWElogo.png")}
                    width="125"
                  ></img>
                </a>
              </li>
              <li className="glide__slide">
                <a href="https://www.swcrc.police.uk/partners" target="_blank" onClick={submitEvent} rel="noreferrer">
                  <img
                    className="img-center"
                    alt="..."
                    height="125"
                    src={require("assets/img/faces/CRC-Logo.png")}
                    width="auto"
                  ></img>
                </a>
              </li>
              <li className="glide__slide">
                <a href="https://regintel-content.thomsonreuters.com/document/I38A25E80F69111EE9F3C948F717317EB" target="_blank" onClick={submitEvent} rel="noreferrer">
                  <img
                    className="img-center"
                    alt="..."
                    height="125"
                    src={require("assets/img/faces/thomsonreuters.png")}
                    width="125"
                  ></img>
                </a>
              </li>
              <li className="glide__slide">
                <a href="https://marketplace.semoto.io/signup" target="_blank" onClick={submitEvent} rel="noreferrer">
                  <img
                    className="img-center"
                    alt="..."
                    height="125"
                    src={require("assets/img/faces/semoto.jpeg")}
                    width="125"
                  ></img>
                </a>
              </li>
              <li className="glide__slide">
                <a href="https://www.aracariproject.io/" target="_blank" onClick={submitEvent} rel="noreferrer">
                  <img
                    className="img-center"
                    alt="..."
                    height="125"
                    src={require("assets/img/faces/aracariproject.png")}
                    width="125"
                  ></img>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Col>
    </section>
  );
}

export default CarouselConstant;
